import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PaymentService } from '../../service/data/payment.service';
import { Payment } from '../../model/payment';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { MessageService } from '../../../core/service/message.service';

@Component({
    selector: 'app-bg-max-import-form',
    templateUrl: './bg-max-import-form.component.html',
    styleUrls: ['./bg-max-import-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BgMaxImportFormComponent implements OnInit {
  constructor(
    private _dataService: PaymentService,
    private _messageService: MessageService,
    cdf: ColumnDefinitionFactory
  ) {
    this.columnDefinition = [
      cdf.createDate('PAYMENT.DATE', 'date'),
      cdf.create('PAYMENT.PAYER_NAME', 'payerName'),
      cdf.createMoney('PAYMENT.AMOUNT', 'amount'),
      cdf.create('PAYMENT.OCR', 'ocr'),
      cdf.create('COMPANY.BANK_GIRO', 'bankgiroNumber'),
    ];
  }

  private _import: string;
  private _file: File;
  columnDefinition: ColumnDefinition[];
  payments: Payment[];
  processing: boolean;

  cancel(): void {
    this._file = null;
    this.payments = null;
  }

  ngOnInit() {}

  onChange(files: FileList | null) {
    if (files && files.length === 1) {
      this._file = files[0];
    } else {
      this._file = null;
    }
  }

  onSubmit(): void {
    if (!this._file) {
      this._messageService.showError('ERROR.BG_MAX_IMPORT_NO_FILE');
      return;
    }

    this.processing = true;
    this._dataService.getPayments(this._file).subscribe(
      data => {
        this._import = data.import;
        this.payments = data.payments.map(item => Object.assign(new Payment(), item));
        this.processing = false;
      },
      error => {
        this.processing = false;
      }
    );
  }

  save(): void {
    if (!this.payments) return;

    this._dataService.import(this._import, this.payments).subscribe(
      res => {
        this.processing = false;
        this.payments = null;
      },
      error => {
        this.processing = false;
      }
    );
  }
}
